import * as React from "react";
import { Text, Checkbox } from "@hubper/core-ui/elements";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
};

function Bool({ value, onChange, label }: Props) {
  return (
    <div
      data-testid="bool-filter"
      onClick={() => onChange(!value)}
      style={{
        flex: "1 1 auto",
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      }}
    >
      <Checkbox value={value} style={{ marginRight: 6 }} />
      <Text
        fs={-1}
        style={{
          textDecoration: value ? "none" : "line-through",
          textTransform: "none"
        }}
      >
        {label}
      </Text>
    </div>
  );
}

export default Bool;
